import { children, field, relation ,text} from "@nozbe/watermelondb/decorators";
import { CATEGORY_SCHEMA } from "../schema";
import { Model } from "@nozbe/watermelondb";

export default class StockCategories extends Model {
    static table = CATEGORY_SCHEMA;

    static associations = {
        reference: { type: "belongs_to", key: "reference_id" },
        business: { type: "belongs_to", key: "business_id" },
        stock: { type: "has_many", foreignKey: "category_id" },
    };

    @text("image_url") image_url;
    @text("level") level;
    @text("name") name;

    @relation("stock_categories", "reference_id") reference;
    @relation("business", "business_id") business;

    @children("stock") stock;

}
